import { Navigate, Route, Routes } from "react-router-dom"

import Error404 from "../../error/Error404.jsx"
import StrategyAI from "./StrategyAI.jsx"

export function StrategyAIBuilder({ sid, data }) {

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/archived/strategy/${sid}/strategy`} replace />} />
      <Route path=":tab/:bid?/*" element={<StrategyAI sid={sid} data={data} />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  )
}

